
export interface optionsConvertDate {
    withTime?: boolean;
}

/**
 * Date formater
 * Convert a raw string date to a dd/mm/yyyy 
 * @param date raw string date
 * @returns date in dd/mm/yyyy format
 */
export const dateConverter = (rawDate: string | null | undefined, option?: optionsConvertDate  ) => {

    if (!rawDate) {
        return ''
    }
    const date = new Date(rawDate);

    let month = String(date.getMonth() + 1);
    let day = String(date.getDate());
    const year = String(date.getFullYear());

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    const dateFormated = `${day}/${month}/${year}`;
 
        let hours = String(date.getHours());
        let minutes = String(date.getMinutes());
        if (hours.length < 2) hours = '0' + hours;
        if (minutes.length < 2) minutes = '0' + minutes;



    return dateFormated + 
    (option?.withTime ? (` à ${hours}:${minutes}`) : "");

}


/**
 * 
 * @param date 
 * @returns 
 */
export const dataObjectToString = (date: Date) =>{
    return date.getDate()+'/'+ (date.getMonth()+1)+'/'+date.getFullYear();
}

export const getNbDayBetweentowDate = (rawDateStart: string, rawDateEnd: string) => {
    const dateStart = new Date(rawDateStart);
    const dateEnd = new Date(rawDateEnd);
    // Calculer la différence en millisecondes
    var differenceEnMillisecondes = dateEnd.getTime() - dateStart.getTime() 

    // Calculer le nombre de jours en divisant par le nombre de millisecondes par jour
    const nombreDeJours = differenceEnMillisecondes / (1000 * 60 * 60 * 24) ;

    return nombreDeJours;
}

export function parseISOStringToDateObject(dateISO: string) {
    var b : any= String(dateISO).split(/\D+/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  }

export  const isEmptyTime = (value?: string) => {
    if (!value) return true;
    if (value === "0001-01-01T00:00:00Z" || value === "0001-01-01T00:00:00.000Z") {
        return true;
    }
    return false;
}